import React from 'react';
import '../../styles/yourOrders.css';
import './styles/orderDetails.css';
import Button from 'react-bulma-components/lib/components/button';

const someDummyData = [{
    orderId: 123,
    userId: 123,
    // Dimension: "10x10",
    technique: "Watercolor on canvas",
    imgUrl: [{ url1: require('../../assets/painting1.png') },
    { url: require('../../assets/painting2.png') },
    { url: require('../../assets/painting3.png') }],
    imgName: "The electric pikachu",
    cost: "500",
    profilePicture: require('../../assets/artist_profilepic.png'),
    ArtistName: "Salvadore Dali",
    Artistlocation: "Mumbai , India",
    buyRequestDone: false,
    likes: 313,
    liked: false,
    Year: 1997,
    artworkStory: "Mona Lisa is an iconic portrait beautifully painted by the legendry artist Leonardo da Vinci. The word “painting” is almost synonymous with Mona Lisa and it is arguably the most popular and talked about work of art. This portrait of a lady with an enigmatic smile is on display at the Louvre, Paris and is a subject of huge debates regarding the identity of the subject.",
    status: "IN PROGRESS",
    timeOfOrder: "19 October 2018",

}
]

const timeline = [
    { timelineheader: "Buy Request Sent", timelineDate: "12th october 2018", status: "DONE" },
    { timelineheader: "Request accepted", timelineDate: "14th october 2018", status: "DONE" },
    { timelineheader: "Payment mode", timelineDate: "16th october 2018", status: "IN PROGRESS" },
    { timelineheader: "Order Shipped", timelineDate: "12th october 2018", logisticsId: "FedEx AWB(FEDEX213124567)", status: "PENDING" },
    { timelineheader: "Order Delivered", timelineDate: "12th october 2018", status: "PENDING" },
]

export default class YourOrders extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        return (
            <div className="back" >
                <div className="heading-welcome">
                    MY ORDERS
                <hr className="horizontal-line"></hr>
                </div>
                <div className="container" id="container-order-details">
                    <div className="order-details-container">
                        <OrderDetails someDummyData={someDummyData} />
                    </div>
                    <div className="order-timeline-container">
                        <div className="order-timeline-header">
                            Order Timeline
                    </div>
                        <OrderTimeline timeline={timeline} />
                    </div>
                </div>
            </div>
        )
    }
}

const OrderDetails = (props) => {
    let { someDummyData } = props;
    return (
        someDummyData.map((el, elIndex) =>

            <div key={elIndex} className="order-details-row">
                <div className="order-product-details">

                    <div className="order-display-picture-thumbnail">
                        <img style={{ height: "100%", width: "100%" }} src={require('../../assets/painting2.png')}></img>
                    </div>
                    <div className="order-name-technique-status">
                        <div className="order-name" id="order-details-name">
                            {el.imgName}
                        </div>
                        <div className="order-technique" id="order-details-technique">
                            {el.technique}@{el.cost}
                        </div>
                        <div className="order-status" id="order-details-status">
                            <InProgressStatusBar someDummyData={el} />
                            <DeliveredStatusBar someDummyData={el} />
                        </div>
                    </div>
                </div>
                <div id="order-detail-btn">
                    <Button id="order-details-button" className={(el.status == "DELIVERED") ? "masterpieces-secondary-buttons" : "masterpieces-primary-buttons"} ><p style={{ fontSize: "0.8em", color: (el.status == "DELIVERED") ? "#333333" : "#FFFF" }}>{(el.status == "DELIVERED") ? "RETURN?" : "MAKE PAYMENT"}</p></Button>
                    <div className="time-of-order" id="time-of-order-details" >
                        {el.timeOfOrder}
                    </div>
                </div>
            </div>
        )
    )
}

const InProgressStatusBar = (props) => {
    let { someDummyData } = props;

    return (
        <div className="InProgress-Status-Bar" style={{ display: (someDummyData.status == "IN PROGRESS") ? "" : "none" }}>
            <div className="status-name"> IN PROGRESS</div>
        </div>
    )
}

const DeliveredStatusBar = (props) => {
    let { someDummyData } = props;
    return (
        <div className="delivered-Status-Bar" style={{ display: (someDummyData.status == "DELIVERED") ? "" : "none" }}>
            <div className="status-name">DELIVERED</div>
        </div>
    )
}

const OrderTimeline = (props) => {
    let { timeline } = props;

    return (
        timeline.map((el, elIndex) =>
            <div key={elIndex} className="timeline-container">
                <div className="timeline-status-ovals">
                    <div className="status-oval-rectangle">
                    </div>
                    <div className="status-section">
                        <StatusIndicator status={el.status} />
                        <div className="status-section-status-name">
                            <div className="timeline-header">
                                {el.timelineheader}
                            </div>
                            <div className="timeline-date">
                                {el.timelineDate}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    )
}

const StatusIndicator = (props) => {
    let { status } = props;
    if (status == "IN PROGRESS") {
    // console.log("came here hihihuhuhaha")
    return (
        <div className="oval-for-status-indication-inProgress">

        </div>
    )
    }
    if(status == "DONE"){
        return(
            <div className="oval-status-indication-done"></div>
        )
    }
    if(status == "PENDING"){
        return(
            <div className="oval-status-indication-pending"></div>
        )
    }
    // }

    return (
        <div></div>
    )
}


// WEBPACK FOOTER //
// ./src/components/orders/orderDetails.js